
import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  const handleHomeClick = () => {
    // ホームページに移動してから商品モニターセクションにスクロール
    if (window.location.pathname === '/') {
      const monitorSection = document.querySelector('#monitor');
      if (monitorSection) {
        monitorSection.scrollIntoView({ behavior: 'smooth' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } else {
      navigate('/');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    }
  };

  const handleApplicationFormClick = () => {
    // ホームページに移動してから応募フォームの見出しにスクロール
    if (window.location.pathname === '/') {
      const applicationFormTitle = document.querySelector('#application-form-title');
      if (applicationFormTitle) {
        const headerHeight = 80;
        const elementPosition = applicationFormTitle.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerHeight;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    } else {
      navigate('/');
      setTimeout(() => {
        const applicationFormTitle = document.querySelector('#application-form-title');
        if (applicationFormTitle) {
          const headerHeight = 80;
          const elementPosition = applicationFormTitle.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerHeight;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  };

  const handleNavClick = (path: string) => {
    navigate(path);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* ロゴとサービス説明 */}
          <div className="md:col-span-2">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/4b22fec895be8868ec3e756cd14dfaa5/408757279e627d3a2d17ea65950b0beb.png"
                  alt="モニター友の会"
                  className="w-12 h-12 object-cover"
                />
              </div>
              <div className="ml-4 flex flex-col">
                <span className="text-2xl font-bold bg-gradient-to-r from-rose-400 to-pink-500 bg-clip-text text-transparent" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                  モニター友の会
                </span>
                <span className="text-xs text-gray-400 -mt-1">Monitor Friends Club</span>
              </div>
            </div>
            <p className="text-gray-300 mb-4">
              商品代金全額事前提供で安心の商品モニターサービス。在宅で気軽に参加でき、正直なレビューで謝礼を受け取れます。
            </p>
          </div>

          {/* サービス */}
          <div>
            <h3 className="text-lg font-semibold mb-4">サービス</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={handleHomeClick}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  商品モニター
                </button>
              </li>
              <li>
                <button 
                  onClick={handleApplicationFormClick}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  応募フォーム
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavClick('/faq')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  よくある質問
                </button>
              </li>
            </ul>
          </div>

          {/* 法的情報 */}
          <div>
            <h3 className="text-lg font-semibold mb-4">法的情報</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => handleNavClick('/terms')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  利用規約
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavClick('/privacy')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  プライバシーポリシー
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavClick('/commerce-law')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  特定商取引法
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* コピーライト */}
        <div className="mt-8 pt-8 border-t border-gray-700 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 モニター友の会. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0">
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white text-sm transition-colors"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
